import React, { useEffect, useState, useCallback, useRef } from "react";
import { FaCalculator } from "react-icons/fa";
import { formatDateWithDayjs, showToast } from "../../../utils/utils";
import { InvoiceDetails, responseStatus } from "../../../locales/en";
import { CURRENCY_FORMAT } from "../../../utils/constants/appConstants";
import { Tooltip as ReactTooltip } from "react-tooltip";
import FeeCalculatorModal from "../../../components/modals/FeeCalculatorModal";
import PropTypes from "prop-types";
import styles from "./../../../assets/scss/custom.module.scss";
import { getFeeCalculatorDataURL } from "../../../utils/constants/apiEndPoints";
import privateAxios from "../../../utils/axiosPrivate";

const FeeCalculator = ({ invData }) => {
  const initialRender = useRef(true);
  const [data, setData] = useState({});
  const [isDate, setDate] = useState("");
  const [addFeeCalculator, setAddFeeCalculator] = useState(false);

  const tooltipsArray = [
    { id: "fees-calc", content: InvoiceDetails?.feeCalculator?.title }
  ];

  const loadFeeCalculatorData = useCallback(async (id, getDate) => {
    try {
      const response = await privateAxios.get(getFeeCalculatorDataURL(id), {
        params: { repayDate: getDate }
      });
      setData(response.data.data);
    } catch (error) {
      showToast(error?.response?.data?.message, responseStatus?.error);
    }
  }, []);

  const toggleFeecalculator = () => setAddFeeCalculator((v) => !v);

  const handleSubmit = (date) => {
    loadFeeCalculatorData(invData?.id, date);
    setDate(date);
  };

  useEffect(() => {
    if (initialRender.current && invData?.id && invData?.repaymentDate) {
      loadFeeCalculatorData(invData?.id, invData?.repaymentDate);
      setDate(invData?.repaymentDate);
      initialRender.current = false;
    }
  }, [loadFeeCalculatorData, invData]);

  return (
    <>
      <div>
        <div className={styles.titleArea}>
          <h5>{InvoiceDetails?.feeCalculator?.title}</h5>
        </div>
        <div className="row">
          <div className="col-12 col-md-6 col-lg-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle} border-bottom`}>
                <h5>
                  {InvoiceDetails?.feeCalculator?.total} (
                  {isDate
                    ? formatDateWithDayjs(isDate, "DD-MMM-YYYY")
                    : InvoiceDetails?.feeCalculator?.today}
                  )
                </h5>
              </div>
              <p>
                {data?.totalOwingAmount
                  ? `${CURRENCY_FORMAT}${data?.totalOwingAmount.toLocaleString("en-US")}`
                  : 0.0}
              </p>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle} border-bottom`}>
                <h5>
                  {InvoiceDetails?.feeCalculator?.feeCalc} (
                  {isDate
                    ? formatDateWithDayjs(isDate, "DD-MMM-YYYY")
                    : `${InvoiceDetails?.feeCalculator?.today}`}
                  )
                </h5>
              </div>
              <p>
                {data?.amount
                  ? `${CURRENCY_FORMAT}${data?.amount.toLocaleString("en-US")}`
                  : 0.0}
              </p>
            </div>
          </div>
          <div className="col-12 col-md-4 col-lg-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>⠀</h5>
              </div>
              <ul
                className={`${styles.btngroupwrap} d-flex justify-content-start align-items-center`}
              >
                <li>
                  <button
                    className={`${styles.btnPrimary} calc-icon added-icon`}
                    data-tooltip-id="fees-calc"
                    onClick={toggleFeecalculator}
                  >
                    <FaCalculator />
                  </button>

                  {tooltipsArray.map(({ id, content }) => (
                    <ReactTooltip
                      key={id}
                      className="tooltipcustom"
                      id={id}
                      place="bottom"
                      content={content}
                    />
                  ))}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-12 col-md-8 col-lg-8 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle} border-bottom`}>
                <h5>
                  {InvoiceDetails?.feeCalculator?.totalOwing} (
                  {isDate
                    ? formatDateWithDayjs(isDate, "DD-MMM-YYYY")
                    : `${InvoiceDetails?.feeCalculator?.today}`}
                  ) ({InvoiceDetails?.feeCalculator?.payment})
                </h5>
              </div>
              <p>
                {data?.totalDueAmount
                  ? `${CURRENCY_FORMAT}${data?.totalDueAmount.toLocaleString("en-US")}`
                  : 0.0}
              </p>
            </div>
          </div>
        </div>
      </div>

      <FeeCalculatorModal
        isOpen={addFeeCalculator}
        toggle={toggleFeecalculator}
        loadFeeCalculatorData={loadFeeCalculatorData}
        onSubmit={handleSubmit}
      />
    </>
  );
};
FeeCalculator.propTypes = {
  invData: PropTypes.object
};

export default FeeCalculator;
